import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const renderInlineText = (text, keyPrefix, italicTerms)=>{
    const urlPattern = "https?:\\/\\/[^\\s]+";
    const italicPattern = italicTerms.map(escapeRegExp).join("|");
    const inlinePattern = new RegExp("(".concat([
        urlPattern,
        italicPattern
    ].filter(Boolean).join("|"), ")"), "g");
    return text.split(inlinePattern).map((part, index)=>{
        if (part.match(/^https?:\/\//)) {
            return /*#__PURE__*/ _jsx("a", {
                href: part,
                target: "_blank",
                rel: "noopener noreferrer",
                children: part
            }, "".concat(keyPrefix, "-link-").concat(index));
        }
        if (italicTerms.includes(part)) {
            return /*#__PURE__*/ _jsx("em", {
                children: part
            }, "".concat(keyPrefix, "-italic-").concat(index));
        }
        return part;
    });
};
export default function FormattedNewsText(param) {
    let { content, boldTerms = [], italicTerms = [], itemId } = param;
    if (boldTerms.length === 0) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: renderInlineText(content, itemId, italicTerms)
        });
    }
    const boldTermPattern = new RegExp("(".concat(boldTerms.map(escapeRegExp).join("|"), ")(?![A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\xff0-9])"), "g");
    const usedBoldTerms = new Set();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: content.split(boldTermPattern).map((part, index)=>{
            if (boldTerms.includes(part) && !usedBoldTerms.has(part)) {
                usedBoldTerms.add(part);
                return /*#__PURE__*/ _jsx("strong", {
                    children: part
                }, "".concat(part, "-").concat(index));
            }
            return renderInlineText(part, "".concat(itemId, "-").concat(index), italicTerms);
        })
    });
}
